import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Container} from '@mui/material';
import TravelMode from './TravelMode';
import PermissionCheck from '../../Components/PermissionCheck';
import Consents from './Consents';
import {useParams} from 'react-router-dom';
import {retrieveProfile} from '../../ProfilesSlice';

// AD-2725 (Maria, 17 October 2026): Consents and Transport are separate tabs; 'part' says which one this is.
const ConsentsTab = ({part}) => {
    const {studentId} = useParams();
    const selectedProfile = useSelector(state => state.profilesInfo.selectedProfile);
    const currentSchool = useSelector(state => state.profilesInfo.currentSchool);
    const dispatch = useDispatch();

    return (
        <Container
            xs={12}
            sm={12}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                padding: 0
            }}
        >
            {part !== 'transport' && (
                <PermissionCheck
                    permissionModule={selectedProfile.isApplicant ? 'ApplicantConsents' : 'StudentConsents'}
                    studentProfile={selectedProfile}
                    render={(readonly) => <Consents
                        readonly={readonly}
                        school={currentSchool}
                        profile={selectedProfile}
                        onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                    />}
                />
            )}
            {part !== 'consents' && (
                <PermissionCheck
                    permissionModule={selectedProfile.isApplicant ? 'ApplicantTravelMode' : 'StudentTravelMode'}
                    studentProfile={selectedProfile}
                    render={(readonly) => <TravelMode
                        readonly={readonly}
                        school={currentSchool}
                        profile={selectedProfile}
                        onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                    />}
                />
            )}
        </Container>
    );
};

ConsentsTab.propTypes = {
    part: PropTypes.oneOf(['consents', 'transport'])
};

export default ConsentsTab;
